import { combineEpics } from "redux-observable";
import { epicInsufficientLevel } from "./insufficient-level/epicInsufficientLevel";
import { epicMissingWorkers } from "./missing-workers/epicMissingWorkers";
import { epicShowMeBuyImprovement } from "./quest-tasks/buy-improvement/epicShowMeBuyImprovement";
import { epicShowMeCollectResource } from "./quest-tasks/collect-resource/epicShowMeCollectResource";
import { epicShowMeEarnResource } from "./quest-tasks/earn-resource/epicShowMeEarnResource";
import { epicShowMeFulfillContract } from "./quest-tasks/fulfill-contract/epicShowMeFulfillContract";
import { epicShowMeHaveBuilding } from "./quest-tasks/have-building/epicShowMeHaveBuilding";
import { epicShowMeHaveExpansion } from "./quest-tasks/have-expansion/epicShowMeHaveExpansion";
import { epicShowMeSpendResource } from "./quest-tasks/spend-resource/epicShowMeSpendResource";
import { epicShowMeStartProduction } from "./quest-tasks/start-production/epicShowMeStartProduction";
import { epicShowMeUseHumus } from "./quest-tasks/use-humus/epicShowMeUseHumus";
import { epicShowMeUseOutskirt } from "./quest-tasks/use-outskirt/epicShowMeUseOutskirt";
export var epicShowMe = combineEpics(epicShowMeUseHumus, epicShowMeHaveBuilding, epicShowMeFulfillContract, epicShowMeCollectResource, epicShowMeStartProduction, epicShowMeHaveExpansion, epicShowMeUseOutskirt, epicShowMeBuyImprovement, epicShowMeSpendResource, epicMissingWorkers, epicInsufficientLevel, epicShowMeEarnResource);



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/epicShowMe.ts
// module id = 2345
// module chunks = 3